(function() {

    'use strict';

    angular.module('app').
    controller('MarketplacesController', MarketplacesController);

    MarketplacesController.$inject = ['$scope', 'MarketPlaceReportTableService', 'MarketPlaceConfigTableService', 'MarketPlaceService', '$routeParams', '$location'];

    function MarketplacesController($scope, MarketPlaceReportTableService, MarketPlaceConfigTableService, MarketPlaceService, $routeParams, $location) {

        var vm = this;

        const tabs = ['configuration', 'reporting'];

        if ($routeParams != null) {
            var params = $routeParams;
            let index = vm.activeIndex = tabs.findIndex(tab => params.tab === tab);
            vm.activeIndex = index > -1 ? index : 0;
        }

        vm.changeTab = changeTab;

        init();

        function init() {
            vm.reportingTableData = MarketPlaceReportTableService;
            vm.configurationTableData = MarketPlaceConfigTableService;
        };

        function changeTab(index) {
            $location.search({ tab: tabs[index] });
            vm.activeIndex = index;
        }
    }

})();



// WEBPACK FOOTER //
// ./js/controllers/MarketplacesController.js